const getResponsePayload = response => {
  if (!response) {
    return {};
  }

  return response.data ? response.data : response;
};

export const getUnauthorizedDestinationUrl = response => {
  const payload = getResponsePayload(response);

  if (payload.destination_url) {
    return payload.destination_url;
  }

  if (
    payload.errorResponse &&
    payload.errorResponse.destination_url
  ) {
    return payload.errorResponse.destination_url;
  }

  if (Array.isArray(payload.data) && payload.data[0]) {
    const firstError = payload.data[0];

    if (
      firstError.errorResponse &&
      firstError.errorResponse.destination_url
    ) {
      return firstError.errorResponse.destination_url;
    }
  }

  if (payload.data && payload.data.destination_url) {
    return payload.data.destination_url;
  }

  return "";
};

export const redirectUnauthorizedUser = response => {
  const destinationUrl = getUnauthorizedDestinationUrl(response);

  if (!destinationUrl) {
    return false;
  }

  const payload = getResponsePayload(response);
  payload.destination_url = destinationUrl;
  document.location.replace(destinationUrl);
  return true;
};

export default {
  getUnauthorizedDestinationUrl,
  redirectUnauthorizedUser
};
